import { CalEventFieldType } from '../constants/cal-event-field-type.js';
export function isServerSetField(fieldId, fields) {
    const field = fields.find((candidate) => candidate.id === fieldId);
    return field?.type === CalEventFieldType.SYSTEM_TIMESTAMP;
}
//# sourceMappingURL=is-server-set-field.js.map